import { Stack, Typography } from "@mui/material";
import { RiskIcon, ShieldIcon } from "../../../images";

const icons = {
  risk: <RiskIcon />,
  shield: <ShieldIcon />,
} as const;

type IconKey = keyof typeof icons;

export const H4Component = ({
  text,
  icon,
  color = "#0097DD",
  fontWeight = 600,
}: {
  text: string;
  icon?: string;
  color?: string;
  fontWeight?: number;
}) => {
  if (!text) return null;
  return (
    <Stack flexDirection="row" alignItems="flex-start" gap="8px">
      {icon && (
        <Stack height="22px" alignItems="center" justifyContent="center">
          {icons[icon as IconKey]}
        </Stack>
      )}

      <Typography
        component="h5"
        sx={{
          color,
          fontSize: "16px",
          fontWeight,
          lineHeight: "22px",
        }}
      >
        {text}
      </Typography>
    </Stack>
  );
};
